<!--麻辣教主投票组件-->
<template>
    <section id="vote" v-if="show">
        <h3 v-if="!isOverdue">投票</h3>
        <h3 v-else :class="{yes:isOverdue}">投票已过期</h3>
        <p :class="{yes:isOverdue}">{{title}}</p>
        <ul>
            <li v-for="(item, n) in list" :key="n">
                <img :src="item.image" alt="" class="fl">
                <div class="fl notVote" v-if="!isVote&&!isOverdue">
                    <span>{{item.title}}</span>
                    <a href="" @click.prevent = "thisgoVote(item.id)">投票</a>
                </div>
                <div class="fl isVote" v-else>
                    <p><span :class="{info:true,misVote:isShow}" >{{item.title}}</span> <span class="fr yes" v-if="item.id == userVoteOptionsId">您的投票</span></p>
                    <!--是否过期：否-->
                    <div id="no" v-if="!isOverdue">
                        <mt-progress :value='item.votes'>
                            <div slot="end" class="nub">{{item.votes }}%</div>
                        </mt-progress>
                    </div>
                    <!--是否过期：是-->
                   <div id="yes" v-else>
                       <mt-progress :value='item.votes'>
                           <div slot="end" class="nub">{{item.votes }}%</div>
                       </mt-progress>
                   </div>
                </div>
            </li>
        </ul>
    </section>
</template>
<script>
    import { Progress } from 'mint-ui';
    import { fetchVoteData ,goVote,fetchChoiceComments,fetchToken} from '../../common/api/homePage';
    import { Indicator } from 'mint-ui';
    import { Toast } from 'mint-ui';
    import {getDownURL} from "../../common/api.config";
    export default {
        props: ['magazineId','token','os','isInAPP','loaded', 'params'],
        data(){
            return{
                show:true,
                list:[],
//                是否显示投票
                isShow:false,
//                是否已投票
                isVote:false,
//                是否过期
                isOverdue:'',
                url:'',
                title:'',
                userVoteOptionsId:'',
                count:'',
                curId:''
            }
        },
        created() {
//            if (this.loaded) {
//                this.getVote();
//            }
//            if(this.token&&this.loaded){
//                this.getVote(this.token);
//            }
        },
        computed:{
            init (){
                if(this.magazineId&&this.token&&this.loaded){
                    this.getVote(this.token);
                }else {
                    if(this.magazineId&&!this.token&&this.loaded){
                        this.getVote();
                    }
                }
            }
        },
        watch:{
            token(curVal,oldVal){
               this.getVote(curVal)
            },
            loaded() {
                this.getVote();
            }
        },
        methods: {
            thisgoVote(id){
                this.curId = id;
                this.vpteClick();
            },
            getVote(token){
                fetchVoteData(this.magazineId,token).then((rep) => {
                    if(rep.data.code === 0){
                        if(!Object.keys(rep.data.data).length){
                            this.show = false;
                            return
                        }
                        let data = rep.data.data.magazineVoteDto;
                        this.isVote = data.userVoteOptionsId>0;
                        this.isOverdue = !data.isOverDue;
                        this.list = data.voteItemList;
                        this.userVoteOptionsId = data.userVoteOptionsId;
                        this.title = data.title;
                        this.count = data.count;
                    }
                });
            },
            isVoteTrue(){
                if(!this.isVote){
                    this.isVote = true;
                }
            },
            vpteClick(){
                let _this = this;
                if(_this.isInAPP){
                    if(_this.token){
                        let obj = {magazineId:_this.magazineId,voteOptionId:_this.curId,accessToken:_this.token};
                        goVote(obj).then((rep) => {
                            if(rep.data.code === 0){
                            //刷新页面
                                _this.getVote(_this.token);
                                Toast({
                                    message: rep.data.msg,
                                    position: 'middle',
                                    duration: 800
                                });
                                setTimeout(this.isVoteTrue,750)
                            }else {
                            //续约
                                Toast({
                                    message: rep.data.msg,
                                    position: 'middle',
                                    duration: 800
                                });
                                if(rep.data.code === 99950006 || rep.data.code === 99950007){
                                    if(_this.os === 'IOS'){
                                        let opentoken = prompt('GTWebCommonGetOpenToken');
                                        fetchToken(opentoken).then((rep)=>{
                                            if(rep.data.code === 0){
                                                _this.token = rep.data.data.accessToken;
                                            }
                                        })
                                    }else{
                                        window.utopa.getOpenToken("getAndrOpenToken");
                                    }
                                }
                            }
                        })
                    }else{
                        if(this.os === 'IOS'){
                            prompt('GTWebCommonGetOpenToken');
                        }else {
                            window.utopa.getOpenToken("getAndrOpenToken");
                        }
                    }
                }else {
                    getDownURL(this.params);
                }
            }
        }
    }
</script>

<style lang="scss">
    @import '../../assets/css/px2rem.scss';
    #vote{
        width:93.6%;
        margin:0 auto;
        margin-top: px2rem(36);
        background: #F6F6F6;
        border: px2rem(1) solid #EEE;
        padding: px2rem(24) 0;
        font-size: px2rem(14);
        margin-bottom: px2rem(24);
        .isOverdue{
            color:#999;
        }
        h3{
            font-size: px2rem(16);
            color: #FF4A2A;
            text-align: center;
            padding-bottom: px2rem(12);
            border-bottom: px2rem(1) solid #eee;
            margin-bottom: px2rem(18);
        }
        .yes{
            color:#999;
        }
        p{
            color:#333;
            font-size: px2rem(16);
            padding-left: px2rem(12);
        }
        ul{
            li{
                overflow: hidden;
                padding: px2rem(12);
                padding-top: px2rem(24);
                border-bottom: px2rem(1) solid #eee;
                img{
                    height:px2rem(54);
                    width:px2rem(54);
                    border-radius: 50%;
                    overflow: hidden;
                    margin:-1px;
                }
                div.notVote{
                    margin-left: px2rem(12);
                    display: flex;
                    justify-content:space-between;
                    height:px2rem(54);
                    width:px2rem(249);
                    span{
                        max-width: px2rem(170);
                        color: #333;
                        padding-right: px2rem(24);
                        margin: auto 0;
                    }
                    a{
                        margin: auto 0;
                        width:px2rem(60);
                        height:px2rem(30);
                        line-height: px2rem(30);
                        color: #fff;
                        text-align: center;
                        font-size: px2rem(16);
                        background-color: #ff4a2a;
                        border-radius: px2rem(15);
                    }
                }
                div.isVote{
                    margin-left: px2rem(14);
                    width:px2rem(244);
                    p{
                        font-size:px2rem(14);
                        max-width:px2rem(220);
                        height:px2rem(20);
                        padding:0;
                        .info{
                            overflow:hidden;
                            text-overflow:ellipsis;
                            white-space:nowrap;
                            max-width: px2rem(220);
                        }
                        .misVote{
                            max-width:px2rem(160);
                        }
                        span{
                            display: inline-block;
                            padding:0;
                        }
                    }
                    .mt-progress{
                        width:px2rem(243);
                        height:px2rem(20);
                        line-height: px2rem(20);
                        .nub{
                            font-size: px2rem(14);
                            color: #666;
                            padding-left: px2rem(12);
                        }
                        .mt-progress-content{
                            width:px2rem(200);
                        }
                        .mt-progress-runway,
                        .mt-progress-progress{
                            height:px2rem(12) !important ;
                            background-color: #fff;
                        }
                        .mt-progress-progress{
                            background-color: #FF4A2A;
                        }
                    }
                    #yes{
                        .mt-progress-progress{
                            background-color: #999;
                        }
                    }
                }
            }
        }
    }
    .mint-indicator-wrapper{
        padding:px2rem(20) !important;
        border-radius: px2rem(5);
        .mint-indicator-spin{
            .mint-spinner-snake{
                height: px2rem(32) !important;
                width: px2rem(32) !important;
            }
        }
        .mint-indicator-text{
            margin-top: px2rem(10);
            font-size: px2rem(16);
        }
    }
    .mint-toast.is-placemiddle{
        padding:px2rem(10) !important;
        .mint-toast-text{
            font-size: px2rem(14);
        }
    }
</style>
